"use strict";

var _toArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'cdr',
    synopsis: 'cdr [ITEM] ...[ITEMS]',
    description: 'Treat input as a const cell and get the rest of the contents after car',
    execute: function execute(_ref) {
      var _ref2 = _toArray(_ref),
          rest = _ref2.slice(1);

      return rest;
    }
  };
};

exports.default = _default;